import React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import { AxiosResponse, CancelToken } from 'axios';
import { useFormData } from '@domain/hooks/use.form.data';
import { useAuth } from '@domain/auth/auth.hook';
import { CustomNoRowsOverlay } from '@components/datagrid/custom.no.rows.overlay';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import MainPagination from '@components/main.pagination';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { GameType } from '@domain/game.selection/types/game.type';
import { useGame } from '@domain/game.selection/game.selection.hook';

const commonsColumns = [
  { field: 'tourneyId', headerName: 'Tourney Id', width: 140, flex: 0.5 },
  { field: 'points', headerName: 'Points', width: 200, flex: 0.5 },
  { field: 'startDate', headerName: 'Start', width: 250, flex: 0.5, ...formatColWithDate },
  { field: 'endDate', headerName: 'End', width: 200, flex: 0.5, ...formatColWithDate },
];

const rexColumns = [
  ...commonsColumns,
  { field: 'position', headerName: 'Position', width: 200, flex: 0.4 },
  { field: 'coins', headerName: 'Coins', width: 200, flex: 0.4 },
  { field: 'collectDate', headerName: 'Collect Date', width: 250, flex: 0.5, ...formatColWithDate },
];

const praiaColumns = [
  { field: 'id', headerName: 'Id', width: 150, flex: 0.5 },
  ...commonsColumns,
  { field: 'gameId', headerName: 'Game', width: 250, flex: 0.5 },
];

interface PlayerTourney {
  tourneyId: number;
}

function createData(playerTourney: PlayerTourney) {
  return { id: playerTourney.tourneyId, ...playerTourney };
}

const PlayerTourneys = ({ player }: PlayerDataProps) => {
  const game = useGame();
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<PlayerTourney[]>(`/admin/tourney/player/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<PlayerTourney[]>;
        throw error;
      });
  }

  const formData = useFormData(pid, runSearch, { autoRequest: true });
  const { response } = formData;
  const result = response?.data;
  const headers = response?.headers;
  const pageCount = parseInt(headers?.totalpages || '1', 10);

  // const rows = result || [];
  const rows = result?.map(createData) || [];

  return (
    <TabTableContainer>
      <DataGrid
        components={{
          NoRowsOverlay: CustomNoRowsOverlay,
          Pagination: MainPagination,
        }}
        componentsProps={{
          pagination: { count: pageCount },
        }}
        rows={rows}
        columns={game.type === GameType.Praia ? praiaColumns : rexColumns}
        loading={formData.loading}
        error={formData.error}
      />
    </TabTableContainer>
  );
};

export default PlayerTourneys;
